import React from 'react'
import Navbar from '../inc/Navbar'
import Canefurnitures from './Canefurnitures'
import { Link } from "react-router-dom";
function Canepage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
         <div className='exportindian'>
                <div className="album py-1">
                  <div className="container mt-3">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Cane Furniture</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
        <Canefurnitures/>
        <br/>
    </div>
  )
}

export default Canepage